import { fetch } from "./base";

export const fetchVidboardAssets = async (cache = true) => {
  return fetch("/graphics/", { cache });
};
